<template>
  <div class="data-overview">
    <div class="data-statistics-container">
      <div class="data-statistics">
        <div class="data-contienr">
          <span>代理总数</span>
          <span>{{ userDetailData.agentCount }}</span>
        </div>
        <div class="current-total">当下所有代理总数</div>
      </div>

      <div class="data-statistics">
        <div class="data-contienr">
          <span>用户总量</span>
          <span>{{ userDetailData.usersAccountCount }}</span>
        </div>
        <div class="current-total">所有代理下的用户总量</div>
      </div>
    </div>

    <div class="main-content">
      <searchBar title="统计概要" @handleQueryDataView="handleQueryDataView" />

      <div class="data-board-container">
        <div class="data-board">
          <div class="data-items">
            <div class="data-type">下载量</div>
            <div class="data-num">{{ userDetailData.newRegisterUserCount }}</div>
          </div>

          <div class="data-items">
            <div class="data-type">注册量</div>
            <div class="data-num">{{ userDetailData.newRegisterUserCount }}</div>
          </div>

          <div class="data-items">
            <div class="data-type">活跃人数</div>
            <div class="data-num">{{ userDetailData.activeUsersCount }}</div>
          </div>

          <div class="data-items">
            <div class="data-type">首充人数</div>
            <div class="data-num">{{ userDetailData.firstDepositUsersCount }}</div>
          </div>

          <div class="data-items">
            <div class="data-type">充值总人数</div>
            <div class="data-num">{{ userDetailData.depositTotalUsersCount }}</div>
          </div>

          <div class="data-items">
            <div class="data-type">充值金额</div>
            <div class="data-num">{{ userDetailData.sumMoneyInAmount }}</div>
          </div>

          <div class="data-items">
            <div class="data-type">投注人数</div>
            <div class="data-num">{{ userDetailData.betTotalUserCount }}</div>
          </div>

          <div class="data-items">
            <div class="data-type">游戏盈亏</div>
            <div class="data-num">{{ userDetailData.profitLoss }}</div>
          </div>

          <div class="data-items">
            <div class="data-type">平台费</div>
            <div class="data-num">{{ userDetailData.platformCost }}</div>
          </div>

          <div class="data-items">
            <div class="data-type">手续费</div>
            <div class="data-num">{{ userDetailData.moneyFee }}</div>
          </div>

          <div class="data-items">
            <div class="data-type">红利</div>
            <div class="data-num">{{ userDetailData.bonusAmount }}</div>
          </div>

          <div class="data-items">
            <div class="data-type">返水</div>
            <div class="data-num">{{ userDetailData.receiveRebate }}</div>
          </div>

          <div class="data-items">
            <div class="data-type">调账</div>
            <div class="data-num">{{ userDetailData.accountRegulation }}</div>
          </div>

          <div class="data-items">
            <div class="data-type">净盈利</div>
            <div class="data-num">{{ userDetailData.netProfit }}</div>
          </div>
        </div>
      </div>

      <searchBar title="数据趋势" @handleAgentCompare="handleAgentCompare" />

      <dataEcharts
        :compare1userDetailData="compare1userDetailData"
        :compare2userDetailData="compare2userDetailData"
        :compareValue1Name1="compareValue1Name1"
        :compareValue1Name2="compareValue1Name2"
      />
    </div>
  </div>
</template>

<script>
import searchBar from "@/components/search-bar";
import dataEcharts from "@/components/data-echarts";
import { apiUserDetailData } from "@/api/userApi";
import { Message } from "element-ui";
import { formatTime, formaTommorrowTime } from "@/utills/formatTime.js";

export default {
  components: {
    searchBar,
    dataEcharts,
  },

  data() {
    return {
      userDetailData: {},
      compare1userDetailData: {},
      compare2userDetailData: {},
      compareValue1Name1: "官方",
      compareValue1Name2: "官方",
    };
  },

  async mounted() {
    const data = {
      agenNickName: "",
      agentAccount: "",
      beginTime: formatTime(Date.now()),
      endTime: formaTommorrowTime(Date.now()),
    };
    const res = await this.sendApiUserDetailData(data);
    if (res.success) {
      this.userDetailData = res.data;
      this.compare1userDetailData = res.data;
      this.compare2userDetailData = res.data;
    }
  },

  methods: {
    async sendApiUserDetailData(data) {
      try {
        const res = await apiUserDetailData(data);
        if (res.success) {
          return res;
        } else {
          Message.error(res.message);
        }
      } catch (error) {
        Message.error("查询失败");
        console.log("error", error);
      }
    },

    async handleQueryDataView(data) {
      const res = await this.sendApiUserDetailData(data);
      if (res.success) {
        this.userDetailData = res.data;
      }
    },

    async handleAgentCompare(data) {
      this.compareValue1Name1 = data.compareValue1Name1;
      this.compareValue1Name2 = data.compareValue1Name2;
      const submitData = {
        agenNickName: "",
        agentAccount: data.compareValue1Name1==='官方'?'':data.compareValue1Name1,
        beginTime: data.beginTime,
        endTime: data.endTime,
      };
      const res = await this.sendApiUserDetailData(submitData);
      if (res.success) {
        this.compare1userDetailData = res.data;
      }

      setTimeout(async () => {
        data.compareValue2
          ? (submitData.agentAccount = data.compareValue1Name2)
          : (submitData.agentAccount = "");
        const res = await this.sendApiUserDetailData(submitData);
        if (res.success) {
          this.compare2userDetailData = res.data;
        }
      }, 200);
    },
  },
};
</script>

<style lang="less" scoped>
.data-overview {
  .data-statistics-container {
    width: 650px;
    display: flex;
    justify-content: space-between;

    .data-statistics {
      width: 300px;
      height: 100px;
      background: #796a67;
      padding-bottom: 20px;
      .data-contienr {
        padding: 50px 0 10px 20px;
        font-size: 22px;
        font-weight: bold;
        width: 200px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        span {
          &:nth-child(2) {
            font-size: 18px;
          }
        }
      }

      .current-total {
        margin-left: 20px;
        font-size: 12px;
        margin-top: 15px;
      }
    }
  }

  .main-content {
    margin-top: 10px;

    .data-board-container {
      height: 400px;
      background: #333333;
      margin-top: 40px;
      margin-bottom: 30px;
      position: relative;
      width: 100%;

      .data-board {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-evenly;
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        width: 100%;
        .data-items {
          width: 9%;
          // width: 120;
          height: 80px;
          background: #fff;
          padding: 10px;
          margin: 20px;
          .data-type {
            font-size: 12px;
          }
          .data-num {
            font-size: 22px;
            margin-top: 1rem;
            text-align: center;
            margin-bottom: 15px;
          }
          .yesterday-data {
            font-size: 12px;
            display: flex;
            justify-content: space-between;
            span {
              &:nth-child(2) {
                color: yellowgreen;
              }
            }
          }
        }
      }
    }
  }
}
</style>